import { render } from "./Horizontal.vue?vue&type=template&id=b8c409ee"
import script from "./Horizontal.vue?vue&type=script&lang=js"
export * from "./Horizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__